import { render } from "./TopBar.vue?vue&type=template&id=822ca242&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=822ca242&scoped=true&lang=css"
import "./TopBar.vue?vue&type=style&index=1&id=822ca242&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822ca242"]])

export default __exports__